const ModelType = {
    offer: 'App\\Models\\Offer',
    holdRequest: 'App\\Models\\HoldRequest',
    enquiry: 'App\\Models\\Enquiry',
};

export default ModelType
